import API from "../../Network/API";
import { isLoaded, isLoading, subTasks } from "../actions";

//SubTasks for Project
export async function getSubTasks(dispatch, getUser, id) {
    dispatch(isLoading());
    try {
      var response = await API.post("epic_info.php", {
        "crop": getUser.corp,
        "ideaId": id,
        "action": "subtasks",
        "projectId":getUser.projectId,
        "userType": getUser.role,
        "empId": getUser.empId
      }, {}, false);
      if (response.status === "True") {
        dispatch(subTasks(response.data));
      } else {
        dispatch(subTasks([]));
      }
    } catch (error) {
      console.log(error)
    }
    dispatch(isLoaded());
  }